const state = {
  offlineReady: false,
  checkOfflineReady: false,
  isRegister: false,
};
const getters = {
  CheckOfflineReady(state) {
    return state.checkOfflineReady;
  },
};
const actions = {
  updateOfflineState(context, payload) {
    context.commit('offlineState', payload);
  },
  updateValueCheckOffline(context, payload) {
    context.commit('checkOfflineState', payload);
  },
  updateIsRegister(context, payload) {
    context.commit('checkIsRegister', payload);
  },
};
const mutations = {
  offlineState(state, data) {
    state.offlineReady = data;
  },
  checkOfflineState(state, data) {
    state.checkOfflineReady = data;
  },
  checkIsRegister(state, data) {
    state.isRegister = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
